"use client";

import { useInfront } from "@/context/infront-context";
import { createInstrumentSlug } from "@/services/infront/utils";
import classNames from "classnames";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";

const ID = "search";

const Search = () => {
  const { isReady, load } = useInfront();
  const router = useRouter();

  const [isOpen, setIsOpen] = useState(false);

  const widgetRef = useRef<any>(null);

  useEffect(() => {
    let active = true;

    load?.(["core", "highstock", "hollowcandlestick", "heikinashi"]).then(
      () => {
        if (!isReady || !active) return;

        widgetRef.current?.destroy();
        widgetRef.current = null;

        const widgetOptions = new window.Infront.SearchBoxOptions();

        widgetOptions.instrumentSelected = (instrument: {
          feed: number;
          ticker: string;
        }) => {
          setIsOpen(false);
          reloadWidget();

          router.push(
            createInstrumentSlug(instrument.feed, instrument.ticker),
          );
        };

        widgetOptions.placeholder = "Sök efter instrument";
        widgetOptions.itemTypes = ["INSTRUMENT"];

        widgetRef.current = window.infront.searchWidget(`#${ID}`, widgetOptions);

        const reloadWidget = () => {
          widgetRef.current?.destroy();
          widgetRef.current = window.infront.searchWidget(`#${ID}`, widgetOptions);
        };
      },
    );

    return () => {
      active = false;
      widgetRef.current?.destroy();
      widgetRef.current = null;
    };
  }, [isReady, router]);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn"
        aria-expanded={isOpen}
      >
        {isOpen ? "Stäng" : "Sök instrument"}
      </button>

      <div
        className={classNames("absolute right-0 -bottom-14", {
          hidden: !isOpen,
        })}
        id={ID}
      />
    </div>
  );
};

export default Search;
